import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { language, t } = useLanguage();

  return (
    <footer className="bg-accent text-white py-8 lg:py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-6 lg:mb-12">
          <div className="md:col-span-2">
            <div className="mb-4">
              <div className="inline-block text-center">
                {language === 'bg' ? (
                  <>
                    <p className="text-xs text-gold font-bold tracking-[0.3em] uppercase mb-1">
                      {t('nav.navFirstLine')}
                    </p>
                    <h3 className="text-2xl font-serif font-bold text-white leading-none tracking-wide">
                      {t('nav.navSecondLine')}
                    </h3>
                  </>
                ) : (
                  <>
                    <h3 className="text-2xl font-serif font-bold text-white leading-none tracking-wide mb-1">
                      {t('nav.navFirstLine')}
                    </h3>
                    <p className="text-xs text-gold font-bold tracking-[0.3em] uppercase">
                      {t('nav.navSecondLine')}
                    </p>
                  </>
                )}
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/p/%D0%90%D0%B4%D0%B2%D0%BE%D0%BA%D0%B0%D1%82-%D0%9F%D0%B5%D1%82%D1%8A%D1%80-%D0%9D%D0%B8%D0%BA%D0%BE%D0%BB%D0%BE%D0%B2-%D0%92%D0%B0%D1%80%D0%BD%D0%B0-100067798608266/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1877F2] rounded-full flex items-center justify-center hover:scale-110 hover:shadow-lg hover:shadow-[#1877F2]/50 transition-all duration-300">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/advokatnikolov/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#0A66C2] rounded-full flex items-center justify-center hover:scale-110 hover:shadow-lg hover:shadow-[#0A66C2]/50 transition-all duration-300">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-300 hover:text-gold transition-colors">{t('nav.home')}</a></li>
              <li><a href="/#about" className="text-gray-300 hover:text-gold transition-colors">{t('nav.about')}</a></li>
              <li><a href="/#practice" className="text-gray-300 hover:text-gold transition-colors">{t('nav.practice')}</a></li>
              <li><a href="/#notable-cases" className="text-gray-300 hover:text-gold transition-colors">{t('nav.notableCases')}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2">
              <li><a href={language === 'bg' ? '/semeino-pravo-roditelski-prava' : '/family-law-parental-rights'} className="text-gray-300 hover:text-gold transition-colors">{t('practice.childProtectionTitle')}</a></li>
              <li><a href={language === 'bg' ? '/zashtita-dlazhnitsi-potrebiteli' : '/debtor-consumer-protection'} className="text-gray-300 hover:text-gold transition-colors">{t('practice.debtorProtectionTitle')}</a></li>
              <li><a href={language === 'bg' ? '/veshtno-pravo-nedvizhimi-imoti' : '/property-law-real-estate'} className="text-gray-300 hover:text-gold transition-colors">{t('practice.propertyLawTitle')}</a></li>
              <li><a href={language === 'bg' ? '/administrativno-pravo' : '/administrative-law'} className="text-gray-300 hover:text-gold transition-colors">{t('practice.administrativeTitle')}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-600 pt-8">
          <div className="text-center text-gray-400">
            <p>{t('footer.copyright')} | <a href="/privacy-policy" className="text-gray-400 hover:text-gold transition-colors">{language === 'bg' ? 'Политика за поверителност' : 'Privacy Policy'}</a> | <button type="button" onClick={() => window.dispatchEvent(new Event('openCookieSettings'))} className="text-gray-400 hover:text-gold transition-colors">{language === 'bg' ? 'Настройки за бисквитки' : 'Cookie settings'}</button></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
